// Time Complexity:  O(|V|^3)
// This function finds the shortest path between all pairs of vertices
// Negative edges are allowed
export function floydWarshall(graph) {
    const visitedNodesIdInOrder = [];
    const startNodeId = graph.startNode
    const finishNodeId = graph.finishNode
    var dist = createDistanceMatrix(graph)
    var next = createNextMatrix(graph, dist)

    // If going from i to k then from k to j is better than
    // directly going from i to j, then update the value of i to j.
    for(let k = 0; k < graph.vertices; k++) {
        // Para simplificar na animacao, visitar cada no um por um
        visitedNodesIdInOrder.push(k)
        for(let i = 0; i < graph.vertices; i++) {
            for(let j = 0; j < graph.vertices; j++) {
                if (dist[i][j] > (dist[i][k] + dist[k][j]) && (dist[k][j] !== Infinity && dist[i][k] !== Infinity)) {
                    dist[i][j] = dist[i][k] + dist[k][j];
                    dist[j][i] = dist[i][k] + dist[k][j]; //undirected graph
                    next[i][j] = next[i][k]
                }
            }
        }
    }
    // Update previous Node IDs
    let path = [], nodeA, i = 0;
    path.push(startNodeId);
    nodeA = startNodeId
    while (nodeA !== finishNodeId) {
        nodeA = next[nodeA][finishNodeId];
        path.push(nodeA);
        graph.list[nodeA].previousNodeId = path[i]
        i++
    }
    return visitedNodesIdInOrder;
}

function createDistanceMatrix(graph) {
    var dist = []
    for(let i = 0; i < graph.vertices; i++) {
        dist[i] = new Array(graph.vertices);
        for(let j = 0; j < graph.vertices; j++) {
            if(i === j) dist[i][j] = 0
            else dist[i][j] = Infinity
        }
    }
    for (let i = 0; i < graph.vertices; i++)
        for(let p = graph.list[i].getHead(); p !== null; p = p.next) 
            dist[i][p.id] = p.distance
    return dist
}

// Create matrix that will keep track of the next node to point 
// if the shortest path changes for any pair of nodes.
function createNextMatrix(graph, dist) {
    var next = []
    for(let i = 0; i < graph.vertices; i++) {
        next[i] = new Array(graph.vertices);
        for(let j = 0; j < graph.vertices; j++) {
            if(dist[i][j] === Infinity) // No edge between nodes i and j
                next[i][j] = -1
            else
                next[i][j] = j
        }
    }
    return next
}